<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a><em>Contents</em></h2>
<p class="part"><span class="nounder" href="#/xhtml/part01#part01" title="Link target outside of Sample">T<span class="small">HE</span> S<span class="small">AINT</span> B<span class="small">RIGID</span> P<span class="small">SALMS</span></span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch01#ch01" title="Link target outside of Sample">Before Autumn</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">Song of Starry-Eyed Children</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Intercession to Saint Brigid</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Mist and Fog</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Song of Earth and Sky</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">The Landscape for Growth</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Eight Modes toward Desire</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">Thin Places</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Ice Palaces</span></p>
<p class="part"><span class="nounder" href="#/xhtml/part02#part02" title="Link target outside of Sample">P<span class="small">YGMALION</span></span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">The Memory of Light</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">Soldiers</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">Fretwork</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">Voices’ End</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">Embers</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">Far from Home</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample">Wise and Innocent</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch17#ch17" title="Link target outside of Sample">The Distance from Here to There</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch18#ch18" title="Link target outside of Sample">Brussels Sprouts</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch19#ch19" title="Link target outside of Sample">Crystalline</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch20#ch20" title="Link target outside of Sample">All Saints’ Day</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch21#ch21" title="Link target outside of Sample">All Souls’ Day</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch22#ch22" title="Link target outside of Sample">Lessons in Nostalgia</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch23#ch23" title="Link target outside of Sample">Enigmatic</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch24#ch24" title="Link target outside of Sample">Apogee</span></p>
<p class="chap"><span class="nounder" href="#/xhtml/ch25#ch25" title="Link target outside of Sample">Triptych</span></p>
<p class="back"><span class="nounder" href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?c9d6dcec